import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Globe2, UserCheck, Compass, CalendarCheck, ShieldCheck, Headset } from 'lucide-react';
export function WhyChooseUs() {
  const reasons = [{
    icon: Globe2,
    title: 'Nationwide Coverage',
    desc: 'Providing reliable residential and commercial moving services across all 50 states, with operational headquarters in Dallas, Texas.'
  }, {
    icon: UserCheck,
    title: 'Professional Trained Movers',
    desc: 'Our crews are professionally trained, uniformed, and committed to handling every move with care, respect, and attention to detail.'
  }, {
    icon: Compass,
    title: 'Guided by Integrity',
    desc: 'We believe moving is more than transportation—it\u2019s helping people through important life transitions with honesty, professionalism, and genuine care for what matters most.'
  }, {
    icon: CalendarCheck,
    title: 'Reliable Scheduling',
    desc: 'We respect your time with clear communication, dependable arrival windows, and efficient execution from start to finish.'
  }, {
    icon: ShieldCheck,
    title: 'Safe & Secure Handling',
    desc: 'Your belongings are treated as if they were our own, with careful handling and comprehensive protection throughout every stage of the move.'
  }, {
    icon: Headset,
    title: 'Dedicated Customer Support',
    desc: 'From your first call to the final delivery, our team provides personalized guidance and responsive support every step of the way.'
  }];
  return <section id="why-us" className="py-24 bg-gray-light relative" data-id="element-240">
      {/* Decorative background element */}
      <div className="absolute top-0 left-0 w-full h-64 bg-white" data-id="element-241" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-242">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-243">
          <h2 className="text-gold font-sans uppercase tracking-[0.2em] font-semibold text-sm mb-4" data-id="element-244">
            The Compass Difference
          </h2>
          <h3 className="text-4xl font-serif text-navy font-bold mb-6" data-id="element-245">
            Why Choose Compass Moving
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10" data-id="element-246">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-10 rounded-lg shadow-sm border border-gray-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300" data-id="element-247">
              <div className="w-14 h-14 bg-navy/5 rounded-full flex items-center justify-center mb-6" data-id="element-248">
                <reason.icon className="w-7 h-7 text-gold" data-id="element-249" />
              </div>
              <h4 className="text-xl font-serif font-bold text-navy mb-3" data-id="element-250">
                {reason.title}
              </h4>
              <p className="text-gray-dark/70 leading-relaxed" data-id="element-251">{reason.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}